import { render, staticRenderFns } from "./Transcripts.vue?vue&type=template&id=1ae82d1b&scoped=true&"
import script from "./Transcripts.vue?vue&type=script&lang=js&"
export * from "./Transcripts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae82d1b",
  null
  
)

export default component.exports